module.exports = __webpack_public_path__ + "lb.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/flag-icon-css/flags/4x3/lb.svg
// module id = 910
// module chunks = 0